<template>
  <div class="deviceList">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">平板设备管理</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input placeholder="请输入设备编号" v-model="keyword" prefix-icon="el-icon-search" size="small" type="text" :maxlength="20" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" class="search-input" clearable>
            </el-input>
          </div>
          <div class="select-container-box" >
            <el-button size="small"  type="info" plain @click="search" class="query" v-if="edit">查询</el-button> 
             <el-button size="small"  type="info" plain @click="add" class="add" v-if="edit">增加</el-button> 
          </div>   
        </div>
      </div>
      <div class="table-container">
        <el-table
          :data="equipmentList"
          style="width: 100%">
          <i slot="empty">
            <span>暂无数据</span>
          </i>
          <el-table-column
            type="index"
            label="序号"
            width="50">
          </el-table-column>
          <el-table-column
            prop="deviceNumber"
            label="设备编号"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="serialNumber"
            label="设备序列号"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            show-overflow-tooltip
            align="center"
            label="负责人"
          >
          </el-table-column>
           <el-table-column
            prop="userPhone"
            label="联系电话"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
           <el-table-column
            prop="createDate"
            show-overflow-tooltip
            align="center"
            :formatter="formatter"
            label="添加时间"
          >
          </el-table-column>
          
          <el-table-column
            label="操作"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                class="content-edit"
                @click="handleEdit(scope.$index, scope.row)"
              >{{edit?'编辑':'查看'}}</span>
              <span
                v-if="edit"
                class="content-del"
                @click="handleDelete(scope.$index, scope.row)"
              >删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change> 
      <!-- 弹窗 -->
      <div v-if="dialogFormVisible"  class="addIot">
        <el-dialog  :title="titleName" :before-close="handleClose" :visible.sync="dialogFormVisible"  width="766px" >
          <el-form :model="equipmentValue" :rules="rules" ref="ruleForms" class="ruleForms">
            <el-form-item label="设备编号" prop="deviceNumber" :label-width="formLabelWidth">
              <el-input
                v-model="equipmentValue.deviceNumber"
                :maxlength="num30"
                placeholder="请输入设备编号"
                :disabled="!edit"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              ></el-input>
            </el-form-item>
            <el-form-item label="设备序列号" prop="serialNumber" :label-width="formLabelWidth">
              <el-input
               :disabled="!edit"
                v-model="equipmentValue.serialNumber"
                :maxlength="num30"
                placeholder="请输入设备序列号"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              ></el-input>
            </el-form-item>
            <el-form-item label="负责人" prop="userId" :label-width="formLabelWidth">
              <el-select
                :disabled="!edit"
                v-model="equipmentValue.userId"
                placeholder="请选择负责人"
                 @change="getPhone" 
              >
                <el-option v-for="item in companyUser" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="联系电话" prop="phone" :label-width="formLabelWidth">
              <el-input
                disabled
                v-model="equipmentValue.phone"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer"  v-if="edit">
            <el-button @click="cancel('ruleForms')" >取 消</el-button>
            <el-button type="primary" @click="save('ruleForms')" >保 存</el-button>
          </div>
        </el-dialog>  
      </div>
      
    </div>
  </div>
</template>


<script>
import PageChange from "../../common/PageChange";
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import { Message } from "element-ui";
import deviceSettingsModule from "../../../store/modules/deviceSetting";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "deviceManage",
  mixins: [mixins],
  components: {
    PageChange
  },
  data() {
    return {
      rowIds: "",
      disabled: true,
      equipmentList: [],
      num30: 30,
      num20: 20,
      num11: 11,
      formLabelWidth: "98px",
      titleName: "",
      dialogFormVisible: false,
      keyword: "",
      companyUser: [], //负责人
      equipmentValue: {
        deviceNumber: "",
        serialNumber: "",
        userId: "",
        phone: ""
      },
      rules: {
        deviceNumber: [
          { required: true, message: "请输入设备编号", trigger: "blur" }
        ],
        serialNumber: [
          { required: true, message: "请输入设备序列号", trigger: "blur" }
        ]
      },
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      },
      rowId: ""
    };
  },
  // watch: {
  //   "curCompany.isQlwVersion"(newValue, old) {
  //     if (
  //       this.curCompany.isQlwVersion == false ||
  //       this.curCompany.isQlwVersion == null
  //     ) {
  //       let permission = this.loginUser.permissions.find(item => {
  //         return item.permissionId == this.permission.deviceManege;
  //       });
  //       if (permission) {
  //         this.edit = !permission.isReadOnly;
  //       }
  //     } else if (this.curCompany.isQlwVersion == true) {
  //  //     }
  //   }
  // },
  async mounted() {
    this.search();
  },
  methods: {
    ...mapActions(deviceSettingsModule, [
      "getEquip",
      "addEquip",
      "deleteEquip",
      "getEdit",
      "editEquip"
    ]),
    ...mapActions(modules.user, ["getEmployees"]),
    async search() {
      let obj = {
        pageIndex: this.pageInfo.pageNumber,
        pageSize: this.pageInfo.pageSize,
        deviceNumber: this.keyword
      };
      await this.$api
        .getEquip(obj)
        .then(rsp => {
          console.log(rsp);

          this.pageInfo.totalPages = rsp.data.total;
          this.equipmentList = rsp.data.list;
        })
        .catch(error => {
          Message.error(error.response.data);
        });
    },
    // 格式化指定列时间
    formatter(row) {
      if (!row.createDate) {
        return false;
      }
      return this.$timeformat(row.createDate);
    },
    //  点击空白处不关闭弹窗
    handleClose(done) {
      console.log(window.event);
      if (window.event && window.event.target.tagName !== "I") {
        return;
      } else {
        done();
      }
    },

    //获取联系方式
    getPhone(e) {
      this.equipmentValue.userId = e;
      this.equipmentValue.phone = Number(
        this.companyUser.find(f => f.id == e).phone
      );
    },

    async add() {
      this.dialogFormVisible = true;
      this.equipmentValue = {};
      this.rowId = "";
      this.titleName = "添加设备";
      this.companyUser = await this.getEmployees(); //获取负责人
    },

    // 编辑获取单个设备数据
    async handleEdit(index, row) {
      this.titleName = "编辑设备";
      this.dialogFormVisible = true;
      this.equipmentValue = {};
      this.companyUser = await this.getEmployees(); //获取负责人
      let result = await this.$api.getEdit(row.id);

      this.rowId = result.data.id;
      this.equipmentValue = {
        deviceNumber: result.data.deviceNumber,
        serialNumber: result.data.serialNumber,
        simCardSerialNumber: result.simCardSerialNumber,
        userId: result.data.userId,
        phone: result.data.userPhone
      };
    },
    // 删除设备
    handleDelete(index, row) {
      this.$confirm("是否删除此记录", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.$api.deleteEquip(row.id);

          // this.equipmentList.splice(index, 1);
          this.search();
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          Message.error(err.response.data);
        });
    },

    // 设备的更新与添加
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            deviceNumber: this.equipmentValue.deviceNumber,
            serialNumber: this.equipmentValue.serialNumber,
            userId: this.equipmentValue.userId
          };
          let objedit = {
            deviceNumber: this.equipmentValue.deviceNumber,
            serialNumber: this.equipmentValue.serialNumber,
            userId: this.equipmentValue.userId,
            id: this.rowId
          };
          if (this.rowId) {
            this.$api
              .editEquip(objedit)
              .then(() => {
                this.$message({
                  type: "success",
                  message: "保存成功"
                });
                this.dialogFormVisible = false;
                this.equipmentValue = {};
                setTimeout(async () => {
                  this.search();
                }, 500);
              })
              .catch(err => {
                Message.error(err.response.data);
              });
          } else {
            this.$api
              .addEquip(obj)
              .then(() => {
                this.$message({
                  type: "success",
                  message: "保存成功"
                });
                this.dialogFormVisible = false;
                this.equipmentValue = {};
                setTimeout(async () => {
                  this.search();
                }, 500);
              })
              .catch(err => {
                console.log(11111, err);

                // Message.error(err.response.data);
              });
          }
        }
      });
    },
    cancel() {
      this.dialogFormVisible = false;
      this.equipmentValue = {};
    }
  }
};
</script>
<style lang="stylus">
.deviceList
  .el-message-box__title {
    /* padding-left: 165px; */
    margin-bottom: 0;
    font-size: 18px;
    line-height: 1;
    color: #333;
    text-align: center;
  }
  .el-select .el-tag {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-color: transparent;
    margin: 2px 0 2px 14px;
    background-color: #f0f2f5;
  }
  // .content-calibrate {
  //   // opacity:0;
  //   font-family: MicrosoftYaHei;
  //   font-size: 14px;
  //   // margin-right: -20px;
  //   cursor: not-allowed;
  //   color: gray;
  // }

  .calibrate {
    // opacity:0;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    margin-right: 20px;
    cursor: pointer;
    color: #45B6F6;
  }
  .calibrates {
    opacity:0;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    margin-right: 20px;
    cursor: pointer;
    color: gray;
  }
  .correct{
    .el-dialog{
      height:480px;
      position:absolute;
      left:50%;
      top:70px;
      border-radius:6px;
      margin-left:-340px;
    }
    .tip{
      display:flex;
      margin-top:18px;
      p{
        font-size:26px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(51,51,51,1);
        padding-left:19px;
      }
    }
    img{
      width:36px;
      height:36px;
    }
    .el-dialog__body {
      padding: 10px 40px;
      color: #606266;
      font-size: 14px;
    }
    
    .content{
      margin-top:42px;
      width:600px;
      height:210px;
      background:rgba(246,247,247,1);
      border-radius:6px;
      .title{
        font-size:18px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(102,102,102,1);
        
      }
      p{
        font-size:20px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(51,51,51,1);
        padding-top:18px; 
      }
      .p1{
        padding-top:24px; 
      }
      .isClear{
        padding-top:44px; 
        text-align :center;
        display:flex;
        justify-content:center;
      }
      .con1{
        padding-top:38px; 
      }
     
      .con{
        padding-top:38px; 
        margin-left:41px;
      }
    }
    .dialog-footer{
      display:flex;
      justify-content:center;
      
      .cancel,.save{
        width:100px;
        height:40px;
        margin-top:20px;
      }
      .save0{
        width:160px;
        height:40px;
        margin-top:20px;
      }
      .cancel{
        
      }
      .save{
        margin-left:22px;
      }
    }
      
  }
  .addIot
  
    .el-dialog
      height:460px;
      position:absolute;
      left:50%;
      top:-50px;
      border-radius:6px;
      margin-left:-340px;
      .el-dialog__header 
        border-radius:6px 6px 0px 0px;
        padding: 16px 20px 16px;
        background:linear-gradient(270deg,rgba(51,137,255,1),rgba(31,156,244,1),rgba(49,170,255,1));
        .el-dialog__title 
          color: #fff;
      .el-input
        width:500px;
      .el-input__inner
        width:500px;
        margin-left:10px;
      .el-select.fishType .el-input , .el-select.fishName  .el-input
        width:245px!important;
      .el-select.fishType .el-input__inner, .el-select.fishName  .el-input__inner
        width:245px!important;
      .el-select.fishName
        margin-left:13px;
      .el-form-item__content
        z-index:999999;
        line-height: 40px;
        position: relative;
        font-size: 14px;
      .el-form .el-form-item .el-form-item__label
        margin-left:65px;
        color:#333;
        font-size:16px;
        text-align:right;
      .ruleForm
        margin-left 0px
      .el-dialog__close 
        color:#fff
      .el-dialog__footer
        position relative
        bottom:12px;
        padding:0px 0px 0px 0px;
        margin-right:370px;
      .el-button--primary
        margin-left:20px
        background: #3389ff;
      .el-button
        width 100px
        height 40px
      .el-button--default
        margin-left:117px
      .el-form-item .el-form-item__label:before
        position: absolute;
        top: 2px;
        left: -12px;
        color: #fe3223;
      .el-form-item__error
        padding-top: 2px;
        position: absolute;
        top: 100%;
        left: 74px;
      .el-icon-date
        position: relative;
      .el-icon-date:before {
        content: "\E608";
        position: absolute;
        left: 13px;
        top: 3px;
      }
    
</style>
